import { gql } from '@apollo/client';
import { FunctionWithFragments } from '@modernloop/shared/components';

import {
  AtsNotSchedulableReason,
  UseApplicationJobStageSchedulable_ApplicationFragment,
} from 'src/generated/mloop-graphql';

type Fragments = {
  application: UseApplicationJobStageSchedulable_ApplicationFragment;
};

/**
 * JobstageId is the selected jobstage in UI
 */
type Props = {
  jobStageId: string;
};

type ReturnType = {
  isSchedulable: boolean;
  reason?: AtsNotSchedulableReason | string;
};

const useApplicationJobStageSchedulable: FunctionWithFragments<Fragments, Props, ReturnType> = (
  { application },
  { jobStageId }
) => {
  /**
   * Check if backend validation has passed
   */
  if (!application?.validateCanEnterScheduleFlow?.valid) {
    return { isSchedulable: false, reason: application?.validateCanEnterScheduleFlow.message || '' };
  }

  /**
   * For some ATSes, scheduling on a different job stage than what the candidate is currently on is not allowed
   */
  if (!application.validateCanMoveStage?.valid && jobStageId !== application.jobStageId) {
    return { isSchedulable: false, reason: application.validateCanMoveStage?.message || '' };
  }

  return { isSchedulable: true };
};

/** Data fetched for checking is schedulable  */
useApplicationJobStageSchedulable.fragments = {
  application: gql`
    fragment useApplicationJobStageSchedulable_application on Application {
      id
      jobStageId
      validateCanEnterScheduleFlow {
        valid
        message
      }
      validateCanMoveStage {
        valid
        message
      }
    }
  `,
};
export default useApplicationJobStageSchedulable;
